// removed by extract-text-webpack-plugin
module.exports = {"colorWhite":"#ffffff","colorModalOverlay":"undefined","colorBoxShadowDark":"rgba(49, 47, 48, 0.15)","unit":"5px","content":"modal__content____3CzLL","editorContent":"modal__editorContent____2gi6s","overlay":"modal__overlay____3uIlJ"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/components/modal/modal.css
// module id = 533
// module chunks = 0